module.exports = __webpack_public_path__ + "img/slice_internal_when_slicing.0fff636d.png";